import styled from 'styled-components';
import Input from '../../../../components/Inputs/Input';

export const Container = styled.div`
    padding: 32px 122px 32px 122px;
`;

export const CustomInput = styled(Input)`
    background-color: ${(props) => props.theme.disabledGrey10} !important;
    color: ${(props) => props.theme.grey} !important;
    border: 1px solid ${(props) => props.theme.lightGrey40};
`;
